import { defu } from "defu";
import _ from "lodash";

import { toastAdd } from "./globalEvents";

export const homeFetchRaw = async <T = unknown>(url: string, options: Record<string, any> = {}) => {
  return homeFetch(url, options, true) as unknown as { _data: T; headers: Headers; status: number };
};

export const homeFetch = async <T = unknown>(
  url: string,
  options: Record<string, any> = {},
  raw?: boolean
): Promise<{
  data?: T;
  _data?: T;
  message?: string;
  status?: string;
}> => {
  const { $i18n } = useNuxtApp();
  const t = $i18n.t;

  const defaultOptions = {
    timeout: 60000,
    headers: {
      "Accept-Language": $i18n.locale.value,
    },
  };
  // for nice deep defaults, please use unjs/defu
  const params = defu(options, defaultOptions);

  const method = raw ? $fetch.raw : $fetch;
  return await method<T>(getStringifiedUrl(url), params)
    .then((response) => {
      return response as { data?: T; _data?: T };
    })
    .catch((error: IServiceError) => {
      const silent = params.silent || false;

      if (error.statusCode == 401 && error.data.url != "/api/auth/logout" && error.data.url != "/api/auth/login") {
        navigateTo({ name: "auth-logout" });
        if (!silent)
          toastAdd({
            group: "session_expired",
            text: t("session_expired_login_again"),
          });
        else console.error(t("session_expired"));
      } else if (!silent) {
        handleErrors(error);
      } else console.error(error);

      throw error;
    });
};

const getStringifiedUrl = (url: string | (() => string)) => {
  let stringifiedUrl = typeof url === "function" ? url() : url;

  if (stringifiedUrl.indexOf("/") === 0) stringifiedUrl = stringifiedUrl.substring(1);
  //if url is not prepended with /api/ then prepend it and not if it is a full url
  if (stringifiedUrl.indexOf("http") !== 0) stringifiedUrl = "/api/" + stringifiedUrl;
  return stringifiedUrl;
};

const handleErrors = (error: IServiceError) => {
  const { $i18n } = useNuxtApp();
  const t = $i18n.t;
  const httpCode = error.data?.statusCode;
  const data = error.data?.data;
  const message = error.data?.message || t("error_occurred_contact_support");
  const session = error.data?.session;
  const toastActions = [
    {
      text: t("copy_for_support"),
      handler: () => {
        copyToClipboard(
          JSON.stringify({
            url: error.data.url,
            message,
            data,
            session,
          })
        );
      },
    },
    /*{
      text: t("send_to_support"),
      handler: () => {
        const workspacesStore = useWorkspacesStore();
        const companyName = workspacesStore.accountName ?? "";
        const errorBody = JSON.stringify({ url: error.data.url, message, data, session });
        const timestamp = new Date().toISOString();

        const body = [
          "",
          "",
          "",
          "",
          "",
          "",
          `[${t("support_email_write")}]`,
          "",
          "",
          "",
          "",
          "",
          "",
          `[${t("support_email_include")}]`,
          "",
          "",
          "",
          "",
          "",
          "",
          `${t("support_email_please")}`,
          "",
          `Company: ${companyName}`,
          `Session UUID: ${session ?? ""}`,
          `Timestamp: ${timestamp}`,
          `Error: ${errorBody}`,
          "",
        ].join("\r\n");

        const a = document.createElement("a");
        a.href = `mailto:it@homerunner.com?subject=${encodeURIComponent(t("support_email_subject", { customer_name: companyName ? `${companyName}:` : "", session: session ? `- ${session}` : "" }))}&body=${encodeURIComponent(body)}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
    },*/
  ];

  if (httpCode === 422) {
    const validationErrors = (data as IValidationError)?.errors;
    //if validationErrors is not an object, show the error message
    if (!_.isObject(validationErrors)) {
      toastAdd({
        actions: toastActions,
        dismissible: true,
        duration: 10000,
        group: error.data?.url + "_validation",
        text: `${t("error_occurred_contact_support")} ${message}`,
        error: true,
      });
      return;
    } else
      Object.entries(validationErrors).forEach(([veKey, ve]) => {
        toastAdd({
          actions: toastActions,
          dismissible: true,
          duration: 10000,
          group: error.data?.url + veKey,
          text: `${message || t("error")} ${ve[0]}`,
          error: true,
        });
      });
  } else
    toastAdd({
      actions: toastActions,
      dismissible: true,
      duration: 10000,
      group: error.data?.url + "_validation",
      text: `${message} ${_.isObject(data) ? JSON.stringify(data) : data || t("error_occurred_contact_support")}`,
      error: true,
    });
};
